import React from 'react';
const POINTS = [{
  icon: '🌱',
  title: 'Professional nutrient deficiency references',
  body: 'Access annotated plant symptoms, nutrient deficiency comparisons, toxicity indicators, and crop-specific visual guides.'
}, {
  icon: '🔍',
  title: 'Structured nutritional assessment process',
  body: 'Move from recognizing visible symptoms to comparing possible causes, reviewing laboratory evidence, and organizing next diagnostic steps.'
}, {
  icon: '🌾',
  title: '6 specialized plant nutrition areas',
  body: 'Nutrient deficiencies, toxicities, soil conditions, tissue analysis, crop-specific disorders, and professional field assessment workflows.'
}, {
  icon: '🎁',
  title: '5 practical professional bonuses',
  body: 'Field inspection tools, sampling protocols, nutrient management planning, crop response monitoring, and technical reporting templates.'
}, {
  icon: '🔄',
  title: 'Ready to use again and again',
  body: 'Return to the system whenever you need to compare symptoms, investigate nutritional concerns, review laboratory findings, or document crop assessments.'
}];
export function NotEbook() {
  return <section className="bg-forest py-5 sm:py-7" data-id="element-105" data-mp="250z2j899xtw5">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-106" data-mp="251ibw0kuz9yk">
        <h2 className="text-center text-2xl leading-none text-white sm:text-4xl" data-id="element-107" data-mp="202ntgzqsznez">
          This isn't just another plant nutrition ebook
        </h2>
        <p className="mt-1 text-center font-display text-base font-bold uppercase leading-tight text-gold sm:text-2xl" data-id="element-108" data-mp="2xp4o1x85jmx1">
          It's a ready-to-use professional visual reference system.
        </p>

        <div className="mt-3 grid gap-2 sm:grid-cols-2 sm:gap-2.5" data-id="element-109" data-mp="2ntta3h4kijqc">
          {POINTS.map((point, i) => <div key={point.title} className={`flex gap-3 rounded-lg border border-white/15 bg-forest-deep p-3 ${i === POINTS.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-110" data-mp="2jshgz1mhjgde" data-mpi={i}>
              <span className="text-xl leading-none" aria-hidden="true" data-id="element-111" data-mp="19rvjt7fnqorl">
                {point.icon}
              </span>
              <div data-id="element-112" data-mp="1epx3nukwqs44">
                <h3 className="text-sm leading-tight text-white sm:text-base" data-id="element-113" data-mp="1eqgiv3j6b2eg">{point.title}</h3>
                <p className="mt-0.5 text-sm leading-snug text-white/80" data-id="element-114" data-mp="ztpjgu9i1qou">{point.body}</p>
              </div>
            </div>)}
        </div>

        <p className="mt-3 text-center font-display text-base font-extrabold uppercase text-white sm:text-xl" data-id="element-115" data-mp="r1413f9s5m0j">
          Less guesswork. Better visual comparisons.{' '}
          <span className="text-gold" data-id="element-116" data-mp="vu70w555hrp6">More structured crop nutrition assessments.</span>
        </p>
      </div>
    </section>;
}